import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import OptionsLevelColumn from './OptionsLevelColumn';
import OptionsEligibilityModal from './InformationModals/OptionsLevelEligibilityModal';
import { strategies, levels } from './EquitiesAccountSettingsHelper';

const OptionsLevel = (props) => {
  const {
    selectedLevel,
    maxOptionsLevel,
    isIraApplication,
    marginAccount,
    meta: { touched, error },
  } = props;

  const [isOptionsEligibilityModalOpen, setOptionsEligibilityModalOpen] = useState(false);

  const toggleOptionsEligibilityModal = () => {
    setOptionsEligibilityModalOpen(!isOptionsEligibilityModalOpen);
  };

  return (
    <div className="row">
      <div className="col col-md-12">
        <h1 className="h2_subHeading">Options Level</h1>
        <p className="panel-question qualification-text">
          You qualify for level {maxOptionsLevel} options strategies!
          <button
            type="button"
            className="optionsLevelHelpButton"
            onClick={toggleOptionsEligibilityModal}
          >
            <i className="material-icons title-help optionsLevelHelpIcon">help</i>
          </button>
        </p>
        <p className="panel-question">Select the desired options level from the available choices below.</p>
        <div className="options-note">
          {isIraApplication && marginAccount &&
            <p className="panel-question"><b>Note:</b> Level 5 is not available for IRA accounts.</p>
          }
          {!marginAccount &&
            <p className="panel-question"><b>Note:</b> Levels 4 and 5 are not available for cash accounts.</p>
          }
        </div>
      </div>
      <div className="options-level-container">
        {/* Left Side - Strategies List */}
        <div className="options-level-strategies">
          <h5 className="strategies-title">STRATEGIES</h5>
          {strategies.map((strategy, index) => (
            <div key={index} className="options-level-strategy">
              {strategy}
            </div>
          ))}
        </div>
        {/* Right Side - Level Selection (Columns) */}
        <div className="options-level-columns">
          {levels.map(level => (
            <Field
              key={level.id}
              name="selectedLevel"
              component={OptionsLevelColumn}
              level={level}
              selectedLevel={selectedLevel}
              maxOptionsLevel={maxOptionsLevel}
              strategies={strategies}
            />
          ))}
        </div>
      </div>
      {touched && error && (
        <div className="col col-md-12">
          <span className="text-danger">{error}</span>
        </div>
      )}
      {isOptionsEligibilityModalOpen && <OptionsEligibilityModal onClose={toggleOptionsEligibilityModal} />}
    </div>
  );
};

OptionsLevel.propTypes = {
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }).isRequired,
  selectedLevel: PropTypes.number,
  maxOptionsLevel: PropTypes.number,
  isIraApplication: PropTypes.bool,
  marginAccount: PropTypes.bool,
};

export default OptionsLevel;
